import Reflux from 'reflux';
import React from 'react';
import { Form, FormGroup, Label, Input, Modal, ModalBody, ModalFooter, Alert, Button } from 'reactstrap'

import AppStore from '~/stores/app.js'
import AppActions from '~/actions/app.js'
import AuthStore from '~/stores/auth.js'
import AuthActions from '~/actions/auth.js'


export default class Login extends Reflux.Component {
	constructor(props) {
		super(props)

		// store subscriptions
		this.stores = [AuthStore, AppStore]

		// local state
		this.state = {
			failed: false,
			email: '',
			password: '',
			showLoginModal: false
		}

		// function bindings
		this.handleEmail = this.handleEmail.bind(this)
		this.handlePassword = this.handlePassword.bind(this)
		this.handleLogin = this.handleLogin.bind(this)
	}

	// ********************************************************************************
	// ********************************************************************************

	render() {
		return (
			<Modal isOpen={this.state.showLoginModal === true}>
				<Form
					onSubmit={(event) => {
						event.preventDefault()
						this.handleLogin()
					}}
				>
					<ModalBody>
						{
							this.state.failed === true &&

							<Alert color="danger">Login failed</Alert>
						}
							<FormGroup>
								<Label for="loginEmail">Email</Label>
								<Input
									id="loginEmail"
									style={{ width: '100%' }}
									type="text"
									value={this.state.email}
									onChange={this.handleEmail}
								/>
							</FormGroup>
							<FormGroup>
								<Label for="loginPassword">Password</Label>
								<Input
									id="loginPassword"
									style={{ width: '100%' }}
									type="password"
									value={this.state.password}
									onChange={this.handlePassword}
								/>
							</FormGroup>
					</ModalBody>
					<ModalFooter>
						<Button onClick={this.handleLogin} color="primary" type="Submit">
							Log In
						</Button>
						<Button onClick={AppActions.hideLoginModal}>Close</Button>
					</ModalFooter>
				</Form>
			</Modal>
		)
	}

	// ********************************************************************************
	// ********************************************************************************

	handleEmail(event) {
		this.setState({ email: event.target.value })
	}

	// ********************************************************************************
	// ********************************************************************************

	handlePassword(event) {
		this.setState({ password: event.target.value })
	}

	// ********************************************************************************
	// ********************************************************************************

	handleLogin() {
		AuthActions.login(
			this.state.email,
			this.state.password
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/login/index.jsx